export enum HistoryReportGetUrlAction {
    Download = "download",
    Reuse = "reuse",
    Generate = "generate"
}